import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as globalActions from "../../../../actions/globalActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import Table, {TABLE_VARIANT_PRIMARY} from "../../../global/generic/Table";

import imgEye from "../../../../resources/img/svgicons/eye.svg";
import imgEyeNo from "../../../../resources/img/svgicons/eye-no.svg";
import imgSearch from "../../../../resources/img/svgicons/search.svg";

class HideItemsModal extends Component {
    changed = false;

    constructor(props) {
        super(props);

        this.state = {
            tab: null,
            productFilter: "",
            productFilterText: "",
            productListLength: 0,
            fandeckFilter: "",
            fandeckFilterText: "",
            fandeckListLength: 0
        };
    }

    componentDidMount = () => {
        this.setState({
            productListLength: this.props.productList.length,
            fandeckListLength: this.props.fandeckList.length,
            tab: "products"
        });
    };

    componentWillUnmount = () => {
        if (this.changed) {
            this.props.dispatchOpenRestartModalAction(this.props.tabId);
        }
    };

    getProductById = (id) => {
        for (let product of this.props.productList) {
            if (product.id === id) {
                return product;
            }
        }

        return null;
    };

    getFandeckById = (id) => {
        for (let fandeck of this.props.fandeckList) {
            if (fandeck.id === id) {
                return fandeck;
            }
        }

        return null;
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseHideItemsModalAction();
    };

    handleProductClick = (event) => {
        let product = this.getProductById(Number(event.currentTarget.dataset.id));

        if (product !== null) {
            this.props.dispatchEnableProductAction(product.id, !product.enabled);
            this.changed = true;
        }
    };

    handleFandeckClick = (event) => {
        let fandeck = this.getFandeckById(Number(event.currentTarget.dataset.id));

        if (fandeck !== null) {
            this.props.dispatchEnableFandeckAction(fandeck.id, !fandeck.enabled);
            this.changed = true;
        }
    };

    handleProductFilterChange = (event) => {
        this.setState({
            productFilter: event.target.value.trim().toLowerCase(),
            productFilterText: event.target.value
        });
    };

    handleFandeckFilterChange = (event) => {
        this.setState({
            fandeckFilter: event.target.value.trim().toLowerCase(),
            fandeckFilterText: event.target.value
        });
    };

    onTabClick = (event) => {
        this.setState({
            tab: event.currentTarget.dataset.tab
        });
    };

    getTabClassName = (tab) => {
        if (tab === this.state.tab) {
            return "active";
        }
        return "";
    };

    getProductsTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(""),
            modelHelper.buildTableCell(<Translate value="general.productName" />),
            modelHelper.buildTableCell(<Translate value="general.productCode" />)
        ]);
    };

    getProductsTableRows = () => {
        let unactiveFilter = this.state.productFilter.length === 0;
        let productList = [];
        for (let product of this.props.productList) {
            if (unactiveFilter || product.displayName.toLowerCase().includes(this.state.productFilter)) {
                productList.push(
                    modelHelper.buildTableRow(
                        [
                            modelHelper.buildTableCell(
                                <div
                                    className="flex-align-center flex-align-center-horizontal cursor-pointer"
                                    onClick={this.handleProductClick}
                                    data-id={product.id}
                                >
                                    <ReactSVG
                                        style={{height: 20, width: 20}}
                                        src={product.enabled ? imgEye : imgEyeNo}
                                        alt="visible"
                                    />
                                </div>
                            ),
                            modelHelper.buildTableCell(product.name),
                            modelHelper.buildTableCell(product.code)
                        ],
                        "padding-15",
                        product.id
                    )
                );
            }
        }
        return productList;
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn(""),
            modelHelper.buildTableColumn("col-6"),
            modelHelper.buildTableColumn("col-5")
        ];
    };

    getProductsTable = () => {
        return (
            <Table
                className="flex-child"
                variant={TABLE_VARIANT_PRIMARY}
                tableHeader={this.getProductsTableHeader()}
                tableRows={this.getProductsTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    getFandecksTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(""),
            modelHelper.buildTableCell(<Translate value="general.fandeckName" />),
            modelHelper.buildTableCell(<Translate value="general.fandeckCode" />)
        ]);
    };

    getFandecksTableRows = () => {
        let unactiveFilter = this.state.fandeckFilter.length === 0;
        let fandeckList = [];
        for (let fandeck of this.props.fandeckList) {
            if (unactiveFilter || fandeck.displayName.toLowerCase().includes(this.state.fandeckFilter)) {
                fandeckList.push(
                    modelHelper.buildTableRow(
                        [
                            modelHelper.buildTableCell(
                                <div
                                    className="flex-align-center flex-align-center-horizontal cursor-pointer"
                                    onClick={this.handleFandeckClick}
                                    data-id={fandeck.id}
                                >
                                    <ReactSVG
                                        style={{height: 20, width: 20}}
                                        src={fandeck.enabled ? imgEye : imgEyeNo}
                                        alt="visible"
                                    />
                                </div>
                            ),
                            modelHelper.buildTableCell(fandeck.name),
                            modelHelper.buildTableCell(fandeck.code)
                        ],
                        "padding-15",
                        fandeck.id
                    )
                );
            }
        }
        return fandeckList;
    };

    getFandecksTable = () => {
        return (
            <Table
                className="flex-child"
                variant={TABLE_VARIANT_PRIMARY}
                tableHeader={this.getFandecksTableHeader()}
                tableRows={this.getFandecksTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    getTabList = () => {
        return (
            <div className="general-tabs primary-tabs">
                <div className="general-tab-list flex flex-align-center-vertical">
                    <span
                        className={"general-tab " + this.getTabClassName("products")}
                        data-tab="products"
                        onClick={this.onTabClick}
                    >
                        <Translate value="general.products" />
                    </span>
                    <div
                        className={"general-tab " + this.getTabClassName("fandecks")}
                        data-tab="fandecks"
                        onClick={this.onTabClick}
                    >
                        <Translate value="general.fandecks" />
                    </div>
                </div>
            </div>
        );
    };

    getActiveTab = () => {
        if (this.state.tab === "products") {
            return (
                <React.Fragment>
                    <div className="col-12 flex padding-bottom-10 flex-align-center-vertical">
                        <div className="col-6">
                            <Translate value="mainTab.hiddenProducts" />:{" "}
                            <span className="color-primary">
                                {this.props.disabledProducts}/{this.state.productListLength}
                            </span>
                        </div>
                        <div className="col-4 align-right">
                            <Input
                                className="primary-input"
                                type="text"
                                value={this.state.productFilterText}
                                onChange={this.handleProductFilterChange}
                                svgAfter={imgSearch}
                            />
                        </div>
                    </div>
                    {this.getProductsTable()}
                </React.Fragment>
            );
        }

        if (this.state.tab === "fandecks") {
            return (
                <React.Fragment>
                    <div className="col-12 flex padding-bottom-10 flex-align-center-vertical">
                        <div className="col-6">
                            <Translate value="mainTab.hiddenFandecks" />:{" "}
                            <span className="color-primary">
                                {this.props.disabledFandecks}/{this.state.fandeckListLength}
                            </span>
                        </div>
                        <div className="col-4 align-right">
                            <Input
                                className="primary-input"
                                type="text"
                                value={this.state.fandeckFilterText}
                                onChange={this.handleFandeckFilterChange}
                                svgAfter={imgSearch}
                            />
                        </div>
                    </div>
                    {this.getFandecksTable()}
                </React.Fragment>
            );
        }

        return "";
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="navigation.navBar.hideItems" />)}
                content={modelHelper.buildModalSection(
                    <div className="general-tabs slim-scroll padding-bottom-10">
                        {this.getTabList()}
                        <div className="general-tab-content flex flex-column">{this.getActiveTab()}</div>
                    </div>,
                    "flex flex-column flex-child fill-flex-space"
                )}
                styles={{minHeight: "50%", minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        productList: store.global.simpleProductList,
        fandeckList: store.global.fandeckList,
        disabledProducts: store.global.disabledProducts,
        disabledFandecks: store.global.disabledFandecks
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseHideItemsModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.HIDE_ITEMS_MODAL));
        },
        dispatchOpenRestartModalAction: (tabId) => {
            dispatch(
                navigationActions.openModalWithParams(tabId, componentTypes.RESTART_MODAL, {
                    type: componentTypes.HIDE_ITEMS_MODAL,
                    message: translate("restartModal.restartIsRequired")
                })
            );
        },
        dispatchEnableProductAction: (productId, enabled) => {
            dispatch(globalActions.enableProduct(productId, enabled));
        },
        dispatchEnableFandeckAction: (fandeckId, enabled) => {
            dispatch(globalActions.enableFandeck(fandeckId, enabled));
        }
    };
};

export default HideItemsModal = connect(mapStoreToProps, mapDispatchToProps)(HideItemsModal);
